import { withSentryReactRouterV6Routing } from '@sentry/react';
import React, { FC } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import { routes } from '../../../routes';
import CreateNewTicket from '../CreateNewTicket/CreateNewTicket';
import EditParameters from '../EditParameters/EditParameters';
import ErrorIndex from '../ErrorIndex/ErrorIndex';
import Home from '../Home/Home';
import PageNotFound from '../PageNotFound/PageNotFound';
import Products from '../Products/Products';
import ResolveTicket from '../ResolveTicket/ResolveTicket';
import ServiceSettings from '../Settings/ServiceSettings/ServiceSettings';
import TicketDetails from '../TicketDetails/TicketDetails';
import Tickets from '../Tickets/Tickets';

const ServiceRouter: FC = () => {
  const SentryRoutes = withSentryReactRouterV6Routing(Routes);

  return (
    <SentryRoutes>
      <Route path={routes.HOME} element={<Home />} />
      <Route path={routes.TICKETS} element={<Tickets />} />
      <Route path={routes.TICKET_DETAILS} element={<TicketDetails />} />
      <Route
        path={`${routes.TICKET_DETAILS}${routes.EDIT_PARAMETERS}`}
        element={<EditParameters />}
      />
      <Route
        path={`${routes.TICKET_DETAILS}${routes.RESOLVE}`}
        element={<ResolveTicket />}
      />
      <Route path={routes.NEW_TICKET} element={<CreateNewTicket />} />
      <Route path={routes.PRODUCTS} element={<Products />} />
      <Route path={routes.ERROR_INDEX} element={<ErrorIndex />} />
      <Route path={routes.SETTINGS} element={<ServiceSettings />} />
      <Route path={routes.PAGE_NOT_FOUND} element={<PageNotFound />} />
      <Route path={'*'} element={<Navigate to={routes.HOME} />} />
    </SentryRoutes>
  );
};

export default ServiceRouter;
